var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.898 11.602c-.28-.34-.61-.61-.99-.81-.51-.29-1.09-.44-1.69-.44H5.768c-.6 0-1.17.15-1.69.44-.39.21-.74.5-1.03.86-.57.73-.84 1.63-.75 2.53l.37 4.67c.13 1.41.3 3.15 3.47 3.15h11.72c3.17 0 3.33-1.74 3.47-3.16l.37-4.65c.09-.84-.13-1.68-.64-2.37l-.16-.22zm-11.3 5.74c-.39 0-.7-.32-.7-.7 0-.38.31-.7.7-.7h4.79c.39 0 .7.32.7.7 0 .39-.31.7-.7.7h-4.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.229 8.86H5.769c-.85 0-1.68.21-2.39.6v-2.8c0-3.57 1.09-4.66 4.66-4.66h1.18c1.43 0 1.88.46 2.46 1.21l1.2 1.6c.25.34.26.36.7.36h2.38c3.45 0 4.58 1.02 4.65 4.29-.73-.4-1.53-.6-2.38-.6z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFolderOpen);
export default __webpack_public_path__ + "static/media/vuesax-bold-folder-open.74b6b077f6cc1e0a41e37e240d4fcb4c.svg";
export { ForwardRef as ReactComponent };